module.exports = {"closeButtonText":"[!!Ćĺŏŝę!!]","thumbNailAlt":"[!!Ƥŕȅvĩȅŵ Įmȃğȇ!!]","next":"[!!Ňęxť Ƥâĝȇ!!]","previous":"[!!Ƥřȅvĭőųŝ Ƥàĝę!!]","addNote":"[!!Åďď ą ƞōŧě...!!]"}


//////////////////
// WEBPACK FOOTER
// ./translations/pseudo.json
// module id = 23
// module chunks = 0